import { render } from "./SupplierDialog.vue?vue&type=template&id=f55201a6"
import script from "./SupplierDialog.vue?vue&type=script&lang=js"
export * from "./SupplierDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__